import * as React from "react";
import { Box, styled } from "@mui/material";
import { SimpleCard } from "app/components";
import CustomButton from "app/components/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useLocation, useRoutes } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTheme } from "@mui/material";
import { format } from "date-fns";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Input,
  Backdrop,
  CircularProgress,
  Grid,
  Popper,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LoadingButton } from "@mui/lab";
import TextField from "@mui/material/TextField";
import { GetComplienceReport } from "app/services/Services";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { Span } from "app/components/Typography";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { differenceInDays, isSameDay } from "date-fns";
import Divider from "@mui/material/Divider";
import moment from "moment";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import useEmpList from "app/hooks/useEmpList";
import Modal from "@mui/material/Modal";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import LeaveTypeChart from "./LeaveTypeChart";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { getEmployeeLeaveReport } from "app/services/LeaveManagement";
import {
  generateErrorMessage,
  generateSuccessMessage,
} from "app/utils/GenerateMessage";
import {
  convertedDate,
  errorMessage,
  attendanceConvertedDate,
  errorMessage3,
  convertedDateToMonthyearFormat2,
  errorMessage2,
} from "app/utils/utils";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Datefilter from "app/components/Datefilter";

const AutoComplete = styled(Autocomplete)(() => ({
  width: "100%",
}));

const Label = styled("span")({
  fontWeight: "bold",
  color: "#666",
  fontSize: "12px",
});

const ValueLeave = styled("div")({
  fontSize: "12px",
  margin: 0, // Remove any default margins
});

const CenteredDivider = styled("hr")({
  margin: "auto",
  width: "80%",
  backgroundColor: "blue",
  marginBottom: 16,
});

const StyledTextArea = styled(TextareaAutosize)`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  resize: vertical;
`;
const Container = styled("div")(({ theme }) => ({
  // margin: "30px",
  [theme.breakpoints.down("sm")]: { margin: "16px" },
  "& .breadcrumb": {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
  },
}));
const Title = styled("span")(() => ({
  fontSize: "1.2rem",
  fontWeight: "600",
  textTransform: "capitalize",
}));
const CardHeader = styled(Box)(() => ({
  display: "flex",
  paddingLeft: "24px",
  paddingRight: "24px",
  marginBottom: "12px",
  alignItems: "center",
  justifyContent: "space-between",
}));
const StyledTextField = styled(TextField)(() => ({
  width: "100%",
  marginBottom: "16px",
}));

const StyledTable = styled(Table)(() => ({
  whiteSpace: "pre",
  "& thead": {
    "& tr": { "& th": { paddingLeft: 0, paddingRight: 0 } },
  },
  "& tbody": {
    "& tr": { "& td": { paddingLeft: 0, textTransform: "capitalize" } },
  },
}));
const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
}));

const EmployeeLeaveReportDetails = (props) => {
  const monthDateFormate = moment(today).format("YYYY-MM-DD");
  const { palette } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const filtered_data = props?.data || [];
  const [search, setSearch] = useState(props?.data[0]?.employeeName);

  const [selectedDate, setSelectedDate] = useState(null);
  const [disableButton, setDisableButton] = useState(false);

  const [loader, setLoader] = useState(false);

  const [loading, setLoading] = useState(false);

  // const totalLeaveCount = data.reduce((total, item) => total + item.leaveCount, 0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const today = new Date();
  const CurentMonth = moment(today).format("YYYY-MM");
  const [dateFieldError, setDateFieldError] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [month, setMonth] = useState();
  const [error, setError] = useState(null);
  const [error2, setError2] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedStatusValue, setSelectedStatusValue] = useState(null);
  const [filterLeaveData, setFilterLeaveData] = useState([]);
  const [isPaginationExport, setIsPaginationExport] = useState(false);

  const ExportToExcel = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const fileName =
      `Leave Report_${search ? search : ""}` +
      "_" +
      "_" +
      `${
        fromDate
          ? moment(fromDate).format("DD-MM-yyyy")
          : month
          ? moment(month).format("MM-yyyy")
          : ""
      }`;
    let exportData;
    const exportToCSV = () => {
      if (isPaginationExport) {
        exportData = paginatedData?.map((object) => {
          const copy = { ...object };
          return copy;
        });
      } else {
        exportData = filtered_data?.map((object) => {
          const copy = { ...object };
          return copy;
        });
      }

      const transformedExportData = exportData.map(
        ({
          employeeName,
          leaveTypeName,
          leaveRequestDate,
          startFrom,
          endTo,
          leaveDays,
          leaveStatus,
        }) => ({
          Name: employeeName,
          Leave_Type: leaveTypeName,
          Date_of_Request: convertedDate(leaveRequestDate),
          Leave_Period: convertedDate(startFrom) + " - " + convertedDate(endTo),
          Leave_Count: leaveDays,
          Status: leaveStatus,
        })
      );
      const ws = XLSX.utils.json_to_sheet(transformedExportData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
      <StyledButton
        variant="contained"
        color="primary"
        startIcon={<SaveAltIcon />}
        onClick={(e) => {
          exportToCSV();
        }}
        disabled={disableButton ? true : false}
      >
        Export
      </StyledButton>
    );
  };
  useEffect(() => {
    setFilterLeaveData(filtered_data);
  }, [filtered_data, location]);


  const handleDate = (newVal) => {
    if (newVal && !isNaN(new Date(newVal).getTime())) {
      const formattedDate = format(new Date(newVal), "yyyy-MM-dd");
      setFromDate(new Date(newVal));
    }
  };

  const handleDateChange = (newVal) => {
    if (newVal && !isNaN(new Date(newVal).getTime())) {
      const formattedDate = format(new Date(newVal), "yyyy-MM-dd");
      setMonth(formattedDate);
      setSelectedDate(new Date(newVal));
      setIsPaginationExport(true);
    } else {
      return;
    }
  };

  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangePage = (_e, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const initialDate = null; // or a specific default date
  const initialSelectedDate = null; // or a specific default date

  const handleReset = () => {
    setIsPaginationExport(false);
    setFromDate(null);
    setSelectedDate(initialSelectedDate);
  };

  useEffect(() => {
    const { hostname } = window.location;
    document.title = `${hostname} | Leave Report `;
  }, []);

  const isDateInRange = (
    leaveStart,
    leaveEnd,
    selectedStartDate,
    selectedEndDate
  ) => {
    const leaveStartDate = new Date(leaveStart);
    const leaveEndDate = new Date(leaveEnd);

    return (
      (leaveStartDate >= selectedStartDate &&
        leaveStartDate <= selectedEndDate) ||
      (leaveEndDate >= selectedStartDate && leaveEndDate <= selectedEndDate) ||
      (leaveStartDate <= selectedStartDate && leaveEndDate >= selectedEndDate)
    );
  };

  const filteredData = filterLeaveData?.filter((req) => {
    const isInRange =
      !fromDate ||
      !selectedDate ||
      isDateInRange(
        req.startFrom,
        req.endTo,
        new Date(fromDate),
        new Date(selectedDate)
      );

    const isValidLeaveStatusAndEmployee =
      req.leaveStatus === filterLeaveData[0]?.leaveStatus &&
      req.employeeName === filterLeaveData[0]?.employeeName;

    return isValidLeaveStatusAndEmployee && isInRange;
  });

  // Paginate the filtered data
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  function getStatusColor(status) {
    switch (status) {
      case "Approved":
        return "green";
      case "Approved-by-Supervisor":
        return "green";
      case "Rejected":
        return "red";
      case "Rejected-by-Supervisor":
        return "red";
      case "Canceled":
        return "orange";
      case "Canceled-by-Supervisor":
        return "orange";
      case "Canceled-by-Admin":
        return "orange";
      default:
        return "black";
    }
  }

  return (
    <Container>
      <SimpleCard>
        <Box width="100%">
          {/* Form Controls */}
          <Grid container spacing={2} alignItems="center" sx={{ mt: 0, mb: 2 }}>
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  format="dd/MM/yyyy"
                  value={fromDate}
                  openTo="day"
                  views={["year", "month", "day"]}
                  onError={(newError) => setError2(newError)}
                  label="From"
                  slotProps={{
                    textField: {
                      variant: "standard",
                      helperText: error2,
                      onChange: (newVal, validate) => {
                        const { validationError } = validate || {};
                        validationError
                          ? setError2(validationError)
                          : setError2("");
                        handleDate(newVal);
                      },
                    },
                  }}
                  onAccept={(newVal) => handleDate(newVal)}
                />
              </LocalizationProvider>
            </Grid>

            <Grid
              item
              lg={3}
              md={3}
              sm={6}
              xs={12}
              sx={{ position: "relative" }}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  format="dd/MM/yyyy"
                  value={selectedDate}
                  onError={(newError) => setError2(newError)}
                  openTo="day"
                  views={["year", "month", "day"]}
                  label="To"
                  slotProps={{
                    textField: {
                      variant: "standard",
                      helperText: error2,
                      onChange: (newVal, validate) => {
                        const { validationError } = validate || {};
                        if (validationError) {
                          setError2(validationError);
                        } else {
                          setError2("");
                          handleDateChange(newVal);
                        }
                      },
                    },
                  }}
                  onAccept={(newVal) => handleDateChange(newVal)}
                  disabled={error2 === "invalidDate"}
                />
              </LocalizationProvider>

              {!!month && (
                <IconButton
                  aria-label="close"
                  onClick={() => setMonth(null)}
                  sx={{
                    position: "absolute",
                    right: 5,
                    top: 5,
                  }}
                ></IconButton>
              )}
            </Grid>

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <ExportToExcel variant="contained" color="primary" />
              <CustomButton
                variant="outlined"
                onClick={handleReset}
                icon={<RestartAltIcon />}
                fullWidth
              >
                Reset
              </CustomButton>
            </Grid>

            {/* <Grid item lg={2} md={2} sm={6} xs={12}>
              <CustomButton
                variant="outlined"
                onClick={handleReset}
                icon={<RestartAltIcon />}
                fullWidth
              >
                Reset
              </CustomButton> */}
          </Grid>
          {/* </Grid> */}

          {/* Leave Request Table */}
          {filteredData?.length > 0 ? (
            <Box width="100%" overflow="auto">
              <TableContainer>
                <Table sx={{ minWidth: 870 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Name</TableCell>
                      <TableCell align="center">Leave Type</TableCell>
                      <TableCell align="center">Date of Request</TableCell>
                      <TableCell align="center">Leave Period</TableCell>
                      <TableCell align="center">Leave Count</TableCell>
                      <TableCell align="center">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData?.map((req, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell align="center">
                            {req.employeeName}
                          </TableCell>
                          <TableCell align="center">
                            {req.leaveTypeName}
                          </TableCell>
                          <TableCell align="center">
                            {convertedDate(req.leaveRequestDate)}
                          </TableCell>
                          <TableCell align="center">
                            {req.startFrom
                              ? convertedDate(req.startFrom)
                              : "N/A"}{" "}
                            - {req.endTo ? convertedDate(req.endTo) : "N/A"}
                          </TableCell>
                          <TableCell align="center">{req.leaveDays}</TableCell>
                          <TableCell
                            align="center"
                            style={{ color: getStatusColor(req.leaveStatus) }}
                          >
                            {req.leaveStatus === "Canceled-by-Admin" ? (
                              <span style={{ color: "orange" }}>
                                Canceled by Admin
                              </span>
                            ) : (
                              req.leaveStatus
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                page={page}
                rowsPerPage={rowsPerPage}
                count={filteredData.length}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 25, 50]}
              />
            </Box>
          ) : (
            !loader && (
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No data available!
              </p>
            )
          )}
        </Box>
      </SimpleCard>
    </Container>
  );
};

export default EmployeeLeaveReportDetails;
